<footer class="bd-footer text-muted bg-light">
  <div class="container-fluid">
	<div class="d-flex justify-content-center mt-1">
		<p>
		  <a href="{{ getLegalPrivacyLink() }}">Legal and Privacy</a>
		  <span> | </span>
		  <a href="{{ getFaqLink() }}">Frequently Asked Questions</a>
		  <span> | </span>
		  <a data-toggle="modal" href="#contact-us-modal">Contact Us</a>
		</p>
	</div>

	<div id="contact-us-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-md">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Need Help or Have Some Questions?</h4>
				</div>
				<div class="modal-body">
					<p>We are here to help. You can review the Frequently Asked Questions or if you need to speak to a representative, we are available to answer your questions at the number below.</p>
					<p>CALL US AT:<br>
						{{ customerServicePhone }}<br>
						Monday - Friday: 7 AM - 5 PM CST
					</p>
					<p>OR FAX AT:<br>
						{{ faxNumber }}
					</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-primary" data-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>

	<span class="d-flex justify-content-center mt-1" [innerHTML]="footerText" > </span>
  </div>
</footer>
